var OrderBundleTariff = /*@__PURE__*/ (function () {
    function OrderBundleTariff() {
        this.errors = [];
    }
    OrderBundleTariff.prototype.setId = function (id) {
        this.id = id;
        return this;
    };
    OrderBundleTariff.prototype.getId = function () {
        return this.id;
    };
    OrderBundleTariff.prototype.setName = function (name) {
        this.nam = name;
        return this;
    };
    OrderBundleTariff.prototype.getName = function () {
        return this.nam;
    };
    OrderBundleTariff.prototype.setPrice = function (price) {
        this.prc = price;
        return this;
    };
    OrderBundleTariff.prototype.getPrice = function () {
        return this.prc;
    };
    OrderBundleTariff.prototype.setPromoPrice = function (promoPrice) {
        this.promo_prc = promoPrice;
        return this;
    };
    OrderBundleTariff.prototype.getPromoPrice = function () {
        return this.promo_prc;
    };
    OrderBundleTariff.prototype.setPromoPriceText = function (promoPriceText) {
        this.promo_prc_text = promoPriceText;
        return this;
    };
    OrderBundleTariff.prototype.getPromoPriceText = function () {
        return this.promo_prc_text;
    };
    OrderBundleTariff.prototype.setRec = function (rec) {
        this.rec = rec;
        return this;
    };
    OrderBundleTariff.prototype.getRec = function () {
        return this.rec;
    };
    OrderBundleTariff.prototype.setValid = function (valid) {
        this.valid = valid;
        return this;
    };
    OrderBundleTariff.prototype.getValid = function () {
        return this.valid;
    };
    OrderBundleTariff.prototype.addError = function (error) {
        this.errors.push(error);
        return this;
    };
    OrderBundleTariff.prototype.getErrors = function () {
        return this.errors;
    };
    OrderBundleTariff.prototype.setType = function (type) {
        this.typ = type;
        return this;
    };
    OrderBundleTariff.prototype.getType = function () {
        return this.typ;
    };
    OrderBundleTariff.prototype.setLevel = function (level) {
        this.lvl = level;
        return this;
    };
    OrderBundleTariff.prototype.getLevel = function () {
        return this.lvl;
    };
    OrderBundleTariff.prototype.setPosition = function (position) {
        this.position = position;
        return this;
    };
    OrderBundleTariff.prototype.getPosition = function () {
        return this.position;
    };
    OrderBundleTariff.prototype.setAdditionalInfo = function (additionalInfo) {
        this.additional_info = additionalInfo;
        return this;
    };
    OrderBundleTariff.prototype.getAdditionalInfo = function () {
        return this.additional_info;
    };
    return OrderBundleTariff;
}());
export { OrderBundleTariff };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.bundle-tariff.ts
// module id = null
// module chunks = 